import flatpickr from 'flatpickr'
import { Japanese } from 'flatpickr/dist/l10n/ja.js'

// #1079 <input data-datepicker> に flatpickr を取り付ける。
// - 送信値は元の<input>に ISO(YYYY-MM-DD) で入り、画面には altInput が「2024年1月5日」形式で表示
// - data-min / data-max で選択範囲を制限(例: 生年月日は今日まで)
// - スマホはネイティブの日付UIの方が扱いやすいため disableMobile は false のまま
// - 値変更時に input/change イベントを発火し、diffSubmit 等の既存の検知に乗せる
const DEFAULTS = {
  locale: Japanese,
  dateFormat: 'Y-m-d',
  altInput: true,
  altFormat: 'Y年n月j日',
  allowInput: false,
  disableMobile: false,
  monthSelectorType: 'dropdown',
}

export function initDatePickers(root = document) {
  root.querySelectorAll('input[data-datepicker]').forEach((input) => {
    if (input._flatpickr || input.dataset.datepickerBound) return

    const options = { ...DEFAULTS }
    if (input.dataset.min) options.minDate = input.dataset.min
    if (input.dataset.max) options.maxDate = input.dataset.max
    if (input.dataset.altFormat) options.altFormat = input.dataset.altFormat
    if (input.placeholder) options.altInputClass = 'flatpickr-input form-control'

    const fp = flatpickr(input, {
      ...options,
      onChange: () => {
        input.dispatchEvent(new Event('input', { bubbles: true }))
        input.dispatchEvent(new Event('change', { bubbles: true }))
      },
    })

    // altInput はプレースホルダ/必須/見た目のクラスを元inputから引き継ぐ
    if (fp.altInput) {
      fp.altInput.placeholder = input.placeholder || '日付を選択'
      if (input.required) fp.altInput.required = true
      fp.altInput.classList.add('biz-datepicker')
      input.classList.forEach((c) => c !== 'flatpickr-input' && fp.altInput.classList.add(c))
    }
    input.dataset.datepickerBound = 'true'
  })
}
